export function ApiKeyGridSkeleton() {
  return (
    <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="flex flex-col gap-3 rounded-lg border-2 border-neutral-200 bg-white p-4 shadow-sm"
        >
          <div className="flex w-full items-center gap-2">
            <div className="h-[28px] w-[28px] flex-shrink-0 animate-pulse rounded-[8px] bg-neutral-300" />
            <div className="h-4 w-full min-w-0 flex-1 animate-pulse rounded bg-neutral-300" />
            <div className="h-6 w-11 flex-shrink-0 animate-pulse rounded-full bg-neutral-300" />
          </div>
        </div>
      ))}
    </div>
  );
}
